import {
  Button,
  Dialog,
  DialogContent,
  CardHeader,
  CardContent,
  CardActions,
  Grid,
  Typography,
  Icon,
} from "../../../../../components";
import { history } from "../../../../../services";

const ErrosMdfeDialog = ({ open, setOpen, errosMdfe, id }) => {
  return (
    <Dialog disableEscapeKeyDown maxWidth="md" fullWidth open={open}>
      <form>
        <DialogContent>
          <CardHeader
            title="Erros MDFe"
            action={
              <>
                <Icon>
                  <i
                    className="ph-fill ph-circle"
                    style={{
                      color: errosMdfe?.status === 400 ? "#EA9D2B" : "#DC3545",
                    }}
                  ></i>
                </Icon>
              </>
            }
          />
          <CardContent>
            <Grid container className="mt-3">
              <Typography>{errosMdfe?.mensagem}</Typography>
            </Grid>
          </CardContent>
          <CardActions className="d-flex justify-content-end">
            <Button
              variant="contained"
              color="padrao"
              onClick={() => {
                setOpen(false);
                if (!id) {
                  history.push(`/faturamento/mdfe/${errosMdfe.idMdfe}`);
                }
              }}
            >
              Fechar
              <i
                className="ph-fill ph-x-circle"
                style={{ fontSize: 22, marginLeft: 10 }}
              ></i>
            </Button>
          </CardActions>
        </DialogContent>
      </form>
    </Dialog>
  );
};

export default ErrosMdfeDialog;
